import { ReactElement, useState, ChangeEvent } from "react";
import { IDelayMeltShop, IEAFProduction, IProductionExtended, IState } from "../../../types";
import { Paper, Tab, Tabs } from "@mui/material";
import GeneralPanel from "./heatPanels/generalPanel";
import SamplePanel from "./heatPanels/samplesPanel";
import { AdditionPanel } from "./heatPanels/additionPanel";
import DelayPanel from "../../interruptions/compoenents/delayPanel";
import HeatChart from "./heatChart";
import TabPanel from "../../../components/tabPanel";
import { useSelector } from "react-redux";

interface IHeatInformationProps {
  productionItem: IProductionExtended;
  height?: number;
}

const HeatInformation = ({ productionItem, height }: IHeatInformationProps): ReactElement => {
  const darkMode = useSelector((state: IState) => state.darkMode);
  const [value, setValue] = useState(0);
  const [selectedDelay, setSelectedDelay] = useState<IDelayMeltShop | null>(null);

  const handleChange = (_event: ChangeEvent<any>, newValue: number) => {
    setValue(newValue);
  };

  const heatData = productionItem as IEAFProduction;

  console.log("heatData", heatData, value);

  return (
    <Paper style={{ height }}>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered={true}
        style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
        <Tab label="General"/>
        <Tab label="Samples"/>
        {/*<Tab label="Buckets" disabled={true}/>*/}
        <Tab label="Alloys"/>
        <Tab label="Delays"/>
      </Tabs>
      <TabPanel value={value} index={0} style={{ padding: "1em" }}>
        <GeneralPanel productionItem={productionItem}/>

        <div style={{ width: "100%", height: 100, marginTop: "1em" }}>
          <HeatChart productionData={productionItem} hideAxisTitle={true} selected={selectedDelay}/>
        </div>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <SamplePanel samples={productionItem.samples} steelCode={heatData.steel.code} zoneCode={heatData.zone.code}/>
      </TabPanel>
      {/*<TabPanel value={value} index={2}>*/}
      {/*  <AdditionPanel additions={heatData.additions} sourceType={0}/>*/}
      {/*</TabPanel>*/}
      <TabPanel value={value} index={2}>
        <AdditionPanel additions={heatData.additions} sourceType={1}/>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <DelayPanel delays={productionItem.delays as IDelayMeltShop[]} selected={selectedDelay} setSelected={d => setSelectedDelay(d as IDelayMeltShop)} />
      </TabPanel>
    </Paper>
  );
};

export default HeatInformation;
